(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('YieldCurvePointDetailController', YieldCurvePointDetailController);

    YieldCurvePointDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'YieldCurvePoint', 'YieldCurveResults'];

    function YieldCurvePointDetailController($scope, $rootScope, $stateParams, previousState, entity, YieldCurvePoint, YieldCurveResults) {
        var vm = this;

        vm.yieldCurvePoint = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('moldovaYieldCurvesApp:yieldCurvePointUpdate', function(event, result) {
            vm.yieldCurvePoint = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
